module.exports = __webpack_public_path__ + "img/img-11.bb71d794.png";